import * as React from 'react';

import styles from './header.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

Header.defaultProps = {
    as: 'div',
};

export function Header({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles.header}>{children}</Tag>;
}
